/**
 * Created by lency on 9/19/16.
 */
import 'lodash';
import 'restangular';

export default 'restangular';



// WEBPACK FOOTER //
// ./src/app/restangular.js